// Duits (de-DE), virtualDevice: zelfde vorm als virtualDevice.nl.ts (golf 3-integratie).
export const appVirtualDeviceDe = {
    title: 'Virtuelles iPad',
    intro: 'Das echte Familienboard, genau wie auf dem Tablet an der Wand.',
    entry: 'Virtuelles iPad',
    entryBody: 'Das Board in deinem Browser, zum Anschauen und Ausprobieren.',
    orientation: 'Ausrichtung',
    landscape: 'Quer',
    portrait: 'Hoch',
    zoom: 'Größe',
    fit: 'Einpassen',
    actual: '100 %',
    profile: 'Tablet von',
    roomEveryone: '{room}, alle',
    roomMembers: '{room}, {names}',
    ownWindow: 'Eigenes Fenster',
    ownWindowLabel: 'Öffne das virtuelle iPad in einem eigenen Fenster mit 1024 × 768',
    pairTitle: 'Dieses virtuelle iPad verbinden',
    pairBody: 'Es wird ein eigenes Tablet in deiner Familie. Du findest es danach bei Tablets und kannst es dort trennen.',
    pairButton: 'Verbinden',
    pairWaiting: 'Das Board erstellt einen Kopplungscode…',
    pairedToast: 'Virtuelles iPad verbunden',
    status: '{name} in {room}',
    moved: 'Das Board zeigt jetzt das Tablet von {room}',
    revoke: 'Trennen',
    revokeTitle: 'Virtuelles iPad trennen?',
    revokeBody: 'Das Board in deinem Browser zeigt danach wieder einen Kopplungscode. Deine echten Tablets merken davon nichts.',
    revoked: 'Virtuelles iPad getrennt',
    hint: 'Jeder Klick ist ein Tippen. Ton und Vorlesen funktionieren nach deinem ersten Klick auf das Board, wie auf dem iPad.',
    storageTitle: 'Dieser Browser hält die Verbindung in der Seite nicht fest',
    storageBody: 'Manche Browser (oft Safari) speichern ein eingebettetes Board getrennt. Öffne das iPad in einem eigenen Fenster: Dort bleibt es verbunden.',
    popupBlocked: 'Dein Browser hat das Fenster blockiert. Erlaube Pop-ups für diese Seite und versuche es noch einmal.',
    frameTitle: 'Familienboard auf dem virtuellen iPad',
    foreignTitle: 'Dieses Board ist als {name} verbunden, ein normales Tablet',
    foreignBody: 'Du hast das Board früher direkt in diesem Browser geöffnet. Verbinde es neu als virtuelles iPad: {name} wird dann getrennt.',
    foreignButton: 'Neu als virtuelles iPad verbinden',
    foreignOtherTitle: 'Dieses Board gehört zu einer anderen Familie',
    foreignOtherBody: 'Dieser Browser ist als Tablet einer anderen Familie verbunden. Trenne ihn dort bei Tablets oder öffne diese Seite in einem privaten Fenster.',
    foreignStatus: '{name} in {room} (normales Tablet)',
    stuckTitle: 'Das Board meldet sich nicht',
    stuckBody: 'Lade das Board neu. Bleibt es leer, öffne es in einem eigenen Fenster.',
    stuckReload: 'Neu laden',
    tag: 'Virtuell',
    openOnDevice: 'Öffnen',
};
//# sourceMappingURL=virtualDevice.de.js.map